export const VERSION = "v3.4.17u";
export const EXT_TITLE = "Webint Center";